import { lazy, Suspense } from 'react';
import { KBarPortal, KBarProvider } from 'kbar';
import { useSelector } from 'react-redux';

import { authToolkit } from '/store/toolkits';
import type { FCWithChildren } from '/common/models';

export const CommandBar = lazy(() =>
  import(/* webpackChunkName: "CommandBar" */ '/common/Kbar/CommandBar').then((module) => ({
    default: module.CommandBar,
  }))
);

export const KBarCustomProvider: FCWithChildren = ({ children }) => {
  const loggedIn = useSelector(authToolkit.selectors.loggedIn);

  return loggedIn ? (
    <KBarProvider
      options={{
        enableHistory: true,
      }}
    >
      <KBarPortal data-testid='kbar-portal'>
        <Suspense>
          <CommandBar />
        </Suspense>
      </KBarPortal>
      {children}
    </KBarProvider>
  ) : (
    <>{children}</>
  );
};
